import React, { forwardRef, useContext } from 'react';
import classNames from 'classnames';
import EnterpriseContext from '../../../../providers/Enterprise/Enterprise.context';
import useDealsFilterOptions from '../../../../hooks/useDealsFilterOptions';
import MultiFilterPanel from 'components/MultiFilterPanel';
import { OpenFieldPanelRef } from 'models/FieldFocusableModal';

import './AnalyticsFitlers.styles.scss';

type AnalyticsFitlersProps = {
  className?: string;
};

const AnalyticsFitlers: React.ForwardRefRenderFunction<
  OpenFieldPanelRef,
  AnalyticsFitlersProps
> = (props, ref) => {
  const { className } = props;

  const { units } = useContext(EnterpriseContext);

  const classes = classNames('analytics-fitlers', className);

  const { filterOptions } = useDealsFilterOptions(units);

  return (
    <MultiFilterPanel ref={ref} className={classes} filters={filterOptions} />
  );
};

export default forwardRef(AnalyticsFitlers);
